import { render, staticRenderFns } from "./intelligentDecisionMakingList.vue?vue&type=template&id=03a96788"
import script from "./intelligentDecisionMakingList.vue?vue&type=script&lang=js"
export * from "./intelligentDecisionMakingList.vue?vue&type=script&lang=js"
import style0 from "./intelligentDecisionMakingList.vue?vue&type=style&index=0&id=03a96788&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports